import { inject, computed } from 'vue';
import kebabCase from 'lodash/kebabCase';

//

/**
 * A container for content to be shown based on tab selection.
 * This component exists mostly for accessibility reasons.  It
 * only renders content if the the corresponding tab has been
 * selected.
 */
var script = {
  name: 'TabPanel',
  props: {
    /** Indicates which `<Tab>` this panel corresponds to */
    value: String
  },
  setup(props) {
    const {
      selectedTab,
      alwaysRenderTabContent
    } = inject('tabs');
    const isActive = computed(() => {
      if (alwaysRenderTabContent.value) return true;
      return props.value === selectedTab.value;
    });
    const shouldShow = computed(() => {
      if (!alwaysRenderTabContent.value) return true;
      return props.value === selectedTab.value;
    });
    return {
      isActive,
      shouldShow,
      kebabCase
    };
  }
};
export { script as default };